module.exports = __webpack_public_path__ + "static/media/Niyati Gulati.9bf687a6.png";